export default __webpack_public_path__ + "static/media/logo-spores-black.ad6eb2c0.svg";